import { render, staticRenderFns } from "./videoViewSetting.vue?vue&type=template&id=1dd13a94&scoped=true&"
import script from "./videoViewSetting.vue?vue&type=script&lang=js&"
export * from "./videoViewSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dd13a94",
  null
  
)

export default component.exports